import React, { Component } from "react";
import CommonUtil from "../../../../../../../utils/commonUtil";


class CircularProgressBar extends Component {
  render() {
    const channel = CommonUtil.getChannel();
    const { percentage = 0, selectedProgressObj } = this.props;
    const radius = 22.6;
    const stroke = (channel === 'wap') ? 5 : 6;
    const normalizedRadius = radius - stroke / 2;
    const circumference = 2 * Math.PI * normalizedRadius;
    const strokeDashoffset =
      circumference - (percentage / 100) * circumference;

    return (
      <div className="progress-container">
        <svg height={radius * 2} width={radius * 2} className="progress-ring">
          {/* Background circle */}
          <circle
            stroke="#D8D8D8"
            fill="transparent"
            strokeWidth={stroke}
            r={normalizedRadius}
            cx={radius}
            cy={radius}
          />
          {/* Foreground progress circle */}
          <circle
            stroke="#07862C"
            fill="transparent"
            strokeWidth={stroke}
            strokeLinecap="round"
            strokeDasharray={`${circumference} ${circumference}`}
            strokeDashoffset={strokeDashoffset}
            r={normalizedRadius}
            cx={radius}
            cy={radius}
          />
        </svg>
        <div className="icon-overlay">
        <img src={selectedProgressObj.giftBoxIcon} alt="gift-icon" className="gift_icon_progress_object"/>
        </div>
      </div>
    );
  }
}

export default CircularProgressBar;
